'use client';
import { useEffect, useState } from 'react';

export function isSmallScreen(): boolean {
  if (typeof window !== 'undefined') {
    return window.innerWidth < 600;
  }
  return false;
}

export function isExtraLargeScreen(): any {
  if (typeof window !== 'undefined') {
    if (window.innerWidth > 1750) {
      return true;
    } else {
      return false;
    }
  }
  return undefined;
}

export function useClientSmallScreen() {
  const [isSmall, setIsSmall] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleResize = () => {
        setIsSmall(isSmallScreen());
      };

      setIsSmall(isSmallScreen());
      window.addEventListener('resize', handleResize);

      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, []);

  return isSmall;
}

export function useClientExtraLargeScreen() {
  const [isExtraLarge, setIsExtraLarge] = useState<boolean | undefined>(undefined);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (!isMounted || typeof window === 'undefined') return;
    
    const handleResize = () => {
      setIsExtraLarge(isExtraLargeScreen());
    };

    setIsExtraLarge(isExtraLargeScreen());
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMounted]);

  return isMounted ? isExtraLarge : undefined;
}
